/**
 * <s-help-recent> — "Recently viewed" guides in the Help Center sidebar.
 * Reads the list that <s-help-doc> records in localStorage, skips the page
 * being read, and stays hidden while empty.
 */
const RECENT_KEY = 'the4-help-recent';

class SHelpRecent extends HTMLElement {
  connectedCallback() {
    const list = this.querySelector('[data-help-recent-list]');
    if (!list) return;
    let items = [];
    try { items = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]'); } catch { items = []; }
    const here = location.pathname;
    items = items.filter((r) => r && r.u && r.t && r.u !== here).slice(0, 5);
    if (!items.length) {
      this.hidden = true;
      return;
    }
    const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]);
    list.innerHTML = items.map((r) => `<li><a href="${esc(r.u)}" class="help-tree-link block truncate rounded-md px-3 py-1 text-on-surface-secondary hover:text-on-surface">${esc(r.t)}</a></li>`).join('');
    this.hidden = false;
  }
}

customElements.define('s-help-recent', SHelpRecent);
